import Storage from 'common/lib/storage';
import { State } from 'modules';
import { Store } from 'redux';
import { getMyId } from 'selectors';

const STORAGE_KEY = 'idMe';

export const saveLastSession = (store: Store<State>) => {
  let idLast: string | undefined = undefined;

  const update = () => {
    const state = store.getState();
    const idMe = getMyId(state);

    if (idMe && idLast !== idMe) {
      idLast = idMe;
      Storage.set(STORAGE_KEY, idMe);
    }
  };

  // use mousedown events to mean "this is the most recent session"
  document.addEventListener('mousedown', update);

  // Watch out of a change that causes the token to get set or unset
  store.subscribe(update);
};

export const getLastMemberId = () => {
  return Storage.get(STORAGE_KEY);
};

export const getLastToken = () => {
  return Storage.get('token');
};



// WEBPACK FOOTER //
// ./app/gamma/src/util/last-session.ts